import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DonVi} from '../../../models/danhmuc/donvi';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {Permission} from '../../../models/security/permission';
import {PermissionService} from '../../../service/security/service-permission';
import {PermissionCodeService} from '../../../service/security/service-permissioncode';
import {GroupPermissionService} from '../../../service/security/service-grouppermission';

@Component({
  templateUrl: './permission.component.html'

})
export class PermissionsComponent implements OnInit, AfterViewInit {
  public language = language;
  public groupId: number =0;
  public onClose: Subject<boolean>;
  public showCheckBox: boolean = true;
  public dataTree: Permission [];
  public dataPermission: Object[] = [];
  public fieldTree: Object;


  @ViewChild('treeview') public tree: TreeViewComponent;


  constructor(public toastr: ToastrService,
              public _bsModalRef: BsModalRef,
              public permissionService: PermissionService,
              public permsssionCodeService: PermissionCodeService,
              public groupPermissionService: GroupPermissionService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.onClose = new Subject();

  }

  public showPermision(id: number): void {
    this.groupId= id;
    this.permissionService.getAll().subscribe(x => {
      this.dataTree = x;
      this.dataPermission = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataPermission.push(
          {
            id: this.dataTree[i].id,
            name: this.dataTree[i].id+'.'+ this.dataTree[i].funcName,
            hasChild: 1,
            expanded: true
          }
        );
      }
      this.permsssionCodeService.getAll().subscribe(y => {
        for(let k=0;k< y.length;k++)
        {
          this.dataPermission.push(
            {
              id: y[k].idCode,
              pid: y[k].funcGroupId,
              name: y[k].funcDetailName,
              hasChild: 0,
              expanded: true
            }
          );
        }
      });
      setTimeout (() => {
        this.fieldTree = {dataSource: this.dataPermission, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild'};
      }, 1000);


    });

  }
public onSelect(): void {
    let arrDV: string = this.tree.getAllCheckedNodes().join();
    this.groupPermissionService.insertMulti(this.groupId, arrDV).subscribe({
        next: () => {
          this.toastr.success(language.message_permission_success, language.message);
          this.onClose.next(true);
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      }
    );
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  public nodeChecked(args): void {


  }

}
